import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { ScopeLevel } from '@bingads-webui-campaign-react/constants';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getGridStyles } from './style';

export const AutomatedCallToActionOptOut = ({ onDataChange, data, level }) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getGridStyles);
  const onChange = useCallback((ev, newData) => {
    onDataChange({
      ...data,
      AutomatedCallToActionOptOut: !newData.checked,
    });
  }, [data, onDataChange]);

  if (level === ScopeLevel.AdGroup) {
    return null;
  }

  return (
    <div>
      <Checkbox
        checked={!data.AutomatedCallToActionOptOut}
        onChange={onChange}
        label={i18n.getString(_TL_('Enable autogenerated calls to action for Multimedia ads'))}
        className={classes.switch}
      />
      <HelpPopup
        topic="pop_BA_MMA_AutoAssets"
        aria-label={i18n.getString(_TL_('Click to learn more about enable autogenerated calls to action for Multimedia ads'))}
      />
    </div>
  );
};

AutomatedCallToActionOptOut.propTypes = {
  onDataChange: PropTypes.func.isRequired,
  data: PropTypes.shape({
    AutomatedCallToActionOptOut: PropTypes.bool,
  }).isRequired,
  level: PropTypes.string.isRequired,
};
